import React from 'react';
import styles from './Footer.module.css';
import AuroraGrain from '../NewLanding/AuroraGrain';

const Footer = ({ title = "Try Zenyai Now" }) => {
  return (
    <>
      <section id="page-footer" className={styles.footerCTA}>
        <div className={styles.auroraBackground}>
          <AuroraGrain
            colorStops={["#00A0B0", "#9C0076", "#FF4500"]}
            blend={0.7}
            amplitude={1.2}
            speed={0.3}
            noiseIntensity={0.05}
            noiseScale={200.0}
          />
        </div>
        <div className={styles.footerContent}>
          {/* Call to Action Card */}
          <div className={styles.ctaCard}>
            <div className={styles.ctaCardContent}>
              <h3 className={styles.ctaTitle}>Ready to Transform Your Audio Workflow?</h3>
              <a href="/dashboard" className={styles.ctaButton}>
                Get Started
              </a>
            </div>
          </div>

          <div className={styles.footerTextContainer}>
            <h2 className={styles.footerTitle}>
              {title}
            </h2>
          </div>
          <div className={styles.linksContainer}>
            <a href="/dashboard" className={styles.footerLinkLarge}>Affiliate</a>
            <a href="/terms" className={styles.footerLinkLarge}>Terms</a>
            <a href="https://discord.gg/Ve9fyDUTev" className={styles.footerLinkLarge}>Discord</a>
            <a href="https://www.linkedin.com/company/zenyai/?viewAsMember=true" className={styles.footerLinkLarge}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                <rect x="2" y="9" width="4" height="12"></rect>
                <circle cx="4" cy="4" r="2"></circle>
              </svg>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
